import $ from 'jquery';
import { decode } from '../../home24/core/base64';
import { redirect } from '../../home24/helpers/location';
import { processGtmVariables } from '../tracking/common/helper';
import * as trackingInstances from '../../home24/helpers/tracking-instances';

const dynamicAnchorsAttribute = 'data-dma';
var selectors = {
  cloakedElements: 'span[data-dma], div[data-dma]',
  cloakedButtons: 'button[data-dma]',
  cloackedMapAreas: '.ma-container'
};

export function init($scope) {
  if (!$scope) {
    $scope = $(document);
  }

  $scope.on(
    'mousemove.links touch.links touchend.links',
    selectors.cloakedElements,
    uncloakElement
  );
  $scope
    .find(selectors.cloackedMapAreas)
    .on('mousemove.links touchend.links', onCloakedMapAreaMouseOver);
  $scope.find(selectors.cloakedButtons).on('click', onCloakedButtonsClick);
}

/**
 * Method wraps element with cloaked url with <a> and propagates all needed events to it
 * Used with click and touch
 *
 * @param {Object} target
 */
export function uncloakElement(target) {
  var $currentTarget = target.currentTarget
    ? $(target.currentTarget)
    : $(target);
  var dataGtm;
  var dataGtmBind;
  var $newElement;
  var targetAttribute;
  var touchAttribute;
  var nofollowAttribute;

  // noinspection JSUnresolvedVariable
  $currentTarget.off('mousemove.links');

  if (!$currentTarget.attr('href') && !$currentTarget.attr('data-dma-done')) {
    $currentTarget.attr('data-dma-done', true);

    $newElement = $('<a></a>');
    targetAttribute = $currentTarget.attr('data-target');
    touchAttribute = $currentTarget.attr('data-disable-href-touch');
    nofollowAttribute = $currentTarget.attr('data-nofollow');

    $newElement.attr(
      'href',
      decodeUrl($currentTarget.attr(dynamicAnchorsAttribute))
    );
    $newElement.attr('class', $currentTarget.attr('class'));
    $currentTarget.addClass('dma');

    if (targetAttribute) {
      $newElement.attr('target', targetAttribute);
    }

    if (touchAttribute) {
      $newElement.attr('data-disable-href-touch', touchAttribute);
    }

    if (nofollowAttribute) {
      $newElement.attr('rel', 'nofollow');
    }

    $currentTarget.wrap($newElement);

    dataGtm = $currentTarget.attr('data-gtm');
    dataGtmBind = $currentTarget.attr('data-gtm-bind');

    if (dataGtm !== undefined && dataGtm.length > 0) {
      $currentTarget
        .parent()
        .attr('data-gtm', dataGtm)
        .bind('click', function() {
          processGtmVariables($(this));
        });
    }

    if (dataGtmBind !== undefined && dataGtmBind.length > 0) {
      trackingInstances
        .get('articleEvents')
        .bindEvents($currentTarget.parent(), dataGtmBind);
    }
  }
}

export function onCloakedMapAreaMouseOver(event) {
  var $currentTarget = $(event.currentTarget);

  $currentTarget.off('mousemove.links');

  // noinspection JSLint
  var htmlContent = $currentTarget.html();

  // can happen that attribute data-um doesn't exist
  var mapName = $currentTarget.find('img').attr('data-um') || '';
  var mapArea = htmlContent
    .replace(/data-dmam="(.*?)"/g, function(match, link) {
      return 'href="' + decodeUrl(link) + '"';
    })
    .replace('data-um=', 'usemap=')
    .replace(/<\/span>/gi, '')
    .replace(/<span /gi, '<area ')
    .replace(/data-/gi, '')
    .replace(
      /<div class="?ma-definition"?.*?>/gi,
      '<map name="' + mapName.substring(1) + '">'
    )
    .replace(/<\/div>/gi, '</map>');

  $currentTarget.html(mapArea);
}

export function onCloakedButtonsClick(event) {
  redirect(decodeUrl($(event.currentTarget).attr('data-dma')));
}

/**
 * decode formated form of a input
 *
 * @param {String} input string to decode
 * @return {String}
 */
export function decodeUrl(input) {
  return decode(input);
}

init();



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/links.js
 **/